module.exports = __webpack_public_path__ + "static/media/pegadaian-logo.339cd413.png";